import type { Job } from '@/services/api/jobs'

import { MOCK_EMPLOYEE_ID, mockCustomers, mockEmployees, mockVehicles } from './seed'

export const mockJobs: Job[] = [
  {
    id: 'job-1',
    jobNumber: 'JOB-1001',
    customerId: mockCustomers[0].driverID,
    vehicleId: mockVehicles[0].driverCarID,
    employeeId: MOCK_EMPLOYEE_ID,
    status: 'completed',
    services: [{ serviceId: 'service-1', quantity: 1, price: 1200 }],
    products: [{ productId: 'product-1', quantity: 1, price: 150 }],
    scheduledDate: '2026-06-20',
    scheduledTime: '09:00',
    estimatedDuration: 90,
    totalAmount: 1350,
    notes: 'Full service and oil change.',
    createdAt: '2026-06-18T08:00:00Z',
    updatedAt: '2026-06-20T11:00:00Z',
  },
  {
    id: 'job-2',
    jobNumber: 'JOB-1002',
    customerId: mockCustomers[1].driverID,
    vehicleId: mockVehicles[1].driverCarID,
    employeeId: mockEmployees[1].employeeID,
    status: 'in_progress',
    services: [{ serviceId: 'service-2', quantity: 1, price: 800 }],
    scheduledDate: '2026-06-30',
    scheduledTime: '10:30',
    estimatedDuration: 60,
    totalAmount: 800,
    notes: 'Brake pad replacement.',
    createdAt: '2026-06-27T08:00:00Z',
    updatedAt: '2026-06-30T10:30:00Z',
  },
  {
    id: 'job-3',
    jobNumber: 'JOB-1003',
    customerId: mockCustomers[2].driverID,
    vehicleId: mockVehicles[2].driverCarID,
    status: 'pending',
    services: [{ serviceId: 'service-3', quantity: 1, price: 500 }],
    scheduledDate: '2026-07-02',
    scheduledTime: '13:00',
    estimatedDuration: 45,
    totalAmount: 500,
    notes: 'Wheel alignment check.',
    createdAt: '2026-06-29T08:00:00Z',
    updatedAt: '2026-06-29T08:00:00Z',
  },
  {
    id: 'job-4',
    jobNumber: 'JOB-1004',
    customerId: mockCustomers[3].driverID,
    vehicleId: mockVehicles[3].driverCarID,
    employeeId: mockEmployees[2].employeeID,
    status: 'completed',
    services: [{ serviceId: 'service-1', quantity: 1, price: 1200 }],
    products: [{ productId: 'product-2', quantity: 2, price: 90 }],
    scheduledDate: '2026-06-15',
    scheduledTime: '08:00',
    estimatedDuration: 120,
    totalAmount: 1380,
    notes: 'Annual inspection.',
    createdAt: '2026-06-10T08:00:00Z',
    updatedAt: '2026-06-15T12:00:00Z',
  },
  {
    id: 'job-5',
    jobNumber: 'JOB-1005',
    customerId: mockCustomers[4].driverID,
    vehicleId: mockVehicles[4].driverCarID,
    status: 'cancelled',
    services: [{ serviceId: 'service-4', quantity: 1, price: 650 }],
    scheduledDate: '2026-06-22',
    scheduledTime: '15:00',
    estimatedDuration: 60,
    totalAmount: 650,
    notes: 'Customer cancelled due to schedule conflict.',
    createdAt: '2026-06-19T08:00:00Z',
    updatedAt: '2026-06-21T09:00:00Z',
  },
  {
    id: 'job-6',
    jobNumber: 'JOB-1006',
    customerId: mockCustomers[5].driverID,
    vehicleId: mockVehicles[5].driverCarID,
    employeeId: mockEmployees[3].employeeID,
    status: 'pending',
    services: [
      { serviceId: 'service-2', quantity: 1, price: 800 },
      { serviceId: 'service-5', quantity: 1, price: 300 },
    ],
    scheduledDate: '2026-07-03',
    scheduledTime: '11:00',
    estimatedDuration: 100,
    totalAmount: 1100,
    notes: 'Tire change and brake inspection.',
    createdAt: '2026-06-30T08:00:00Z',
    updatedAt: '2026-06-30T08:00:00Z',
  },
]
